import { render, staticRenderFns } from "./DualListSelect.vue?vue&type=template&id=1a995e47&scoped=true"
import script from "./DualListSelect.vue?vue&type=script&lang=js"
export * from "./DualListSelect.vue?vue&type=script&lang=js"
import style0 from "./DualListSelect.vue?vue&type=style&index=0&id=1a995e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a995e47",
  null
  
)

export default component.exports